import React, {Component} from 'react';
class ImageViewer extends Component{
    downloadImage(){
        let image = new Image();
        image.src = "data:image/jpeg;base64," + this.props.data;

        let w = window.open("");
        w.document.write(image.outerHTML);
    }

    render(){
        if (this.props.largeMode === 1){
            if (this.props.data === null || this.props.data === undefined || this.props.data === ''){
                return (<></>);
            }
            return (
                <div>
                    <img className="imageBox linkTo" alt="" 
                        width={ this.props.width } height={this.props.height} 
                        src={`data:image/jpeg;base64,${this.props.data}`} 
                        name={this.props.updated} 
                        onClick={ this.downloadImage.bind(this) } /><br/>{ this.props.filename }
                </div>
            );
        }

        if (this.props.data === null || this.props.data === undefined || this.props.data === ''){
            return (<></>);
        }
        return (
            <div>
                <img className="imageBox linkTo" alt="" 
                    width={ this.props.width } height={this.props.height} 
                    src={`data:image/jpeg;base64,${this.props.data}`} 
                    name={this.props.updated} 
                    onClick={ this.downloadImage.bind(this) } />{ this.props.filename }
            </div>
        );
    }
}

export default ImageViewer;